import lockScroll from '../__utils/lockScroll';

class videoLightbox {
    constructor() {
        this.btnOpenLightbox = document.querySelectorAll('.js-play-video');
        this.lightboxClose = document.querySelectorAll('.video-lightbox__close');
        this.lightboxWrapper = document.querySelector('.video-lightbox');
        this.player = document.getElementById('player');
        this.isIframe = false;
    }

    init() {
        this.btnOpenLightbox.forEach(btn => btn.addEventListener('click', this.openLightbox.bind(this)));
        this.lightboxClose.forEach(btn => btn.addEventListener('click', this.closeLightbox.bind(this)));

        if( this.lightboxWrapper ) {
            this.lightboxWrapper.addEventListener('click', this.closeLightbox.bind(this));
        }
    }

    openLightbox(e) {
        e.preventDefault();
        const url = e.target.dataset.video;
        const ds = e.target;
        
        if (!this.isIframe) {
            const iframe = document.createElement('iframe');
            this.player.appendChild(iframe);
            this.isIframe = true;
        }
        const iframeVideo = this.player.querySelector('iframe');

        if (this.isYT(url) || this.isVimeo(url)) {
            iframeVideo.setAttribute('allow', 'autoplay');
            iframeVideo.src = url;
            iframeVideo.src += '&autoplay=1';
        } else if (this.isWistia(url)) {
            const id = this.isWistia(url);
            iframeVideo.src = `https://fast.wistia.net/embed/iframe/${id}`;
            iframeVideo.src += '?volume=1&muted=0&autoPlay=1';
        }
        this.lightboxWrapper.classList.add('active');
        lockScroll.lock();
    }

    closeLightbox() {
        this.player.querySelector('iframe').setAttribute('src', '');
        this.lightboxWrapper.classList.remove('active');
        lockScroll.unlock();
    }

    keyDown(e) {
        const lightboxWrapper = document.querySelector('.video-lightbox__iframe-wrapper.active');
        if (e.keyCode == 27 && lightboxWrapper) {
            this.closeLightbox();
        }
    }

    isYT(url) {
        const yt = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        return (url.match(yt)) ? RegExp.$1 : false;
    }

    isVimeo(url) {
        const vimeo = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
        return (url.match(vimeo)) ? RegExp.$5 : false;
    }

    isWistia(url) {
        const wistia = /(?:(?:medias|iframe)\/|wvideo=)([\w-]+)/;
        return (url.match(wistia)) ? RegExp.$1 : false;
    }
}

export default new videoLightbox();
